import { tr, usePartnerTranslation } from "../../../lib/language";
import React from "react";
import { Check } from "lucide-react";
import { cn } from "../../../lib/utils";
import { STEPS } from "./wizardConstants";

const WizardStepper = ({ current, completed = {}, onJump, hideStart = false }) => {
  usePartnerTranslation();
  const HIDDEN_IN_EDIT = new Set(["acknowledge", "start"]);
  const visibleSteps = hideStart
    ? STEPS.filter((s) => !HIDDEN_IN_EDIT.has(s.key))
    : STEPS;
  return (
    <nav
      aria-label={tr("Wizard steps")}
      data-testid="wizard-stepper"
      className="flex flex-wrap items-center gap-x-3 gap-y-2"
    >
      {visibleSteps.map((s, visIdx) => {
        // Real index inside the canonical STEPS array (so jumps still match).
        const idx = STEPS.findIndex((x) => x.key === s.key);
        const isActive = idx === current;
        const isDone = !!completed[s.key] && idx !== current;
        const isFuture = idx > current && !isDone;
        return (
          <React.Fragment key={s.key}>
            <button
              type="button"
              data-testid={`stepper-${s.key}`}
              onClick={() => onJump?.(idx)}
              disabled={isFuture}
              className={cn(
                "inline-flex items-center gap-2 rounded-full px-3 py-1.5 text-xs font-semibold transition-colors",
                isActive
                  ? "bg-[#FF5757] text-white"
                  : isDone
                  ? "bg-[#FFEFEF] text-[#9B0000] hover:bg-[#FFE0E0]"
                  : "bg-[#F3EEEE] text-[#6B7280] hover:bg-[#EAECEF] disabled:cursor-not-allowed disabled:hover:bg-[#F3EEEE]",
              )}
            >
              <span
                className={cn(
                  "inline-flex h-5 w-5 items-center justify-center rounded-full text-[11px] font-bold",
                  isActive
                    ? "bg-white text-[#FF5757]"
                    : isDone
                    ? "bg-[#FF5757] text-white"
                    : "bg-white text-[#6B7280]",
                )}
              >
                {isDone ? <Check className="h-3 w-3" strokeWidth={2.4} /> : visIdx + 1}
              </span>
              {s.label}
            </button>
            {visIdx < visibleSteps.length - 1 && (
              <span aria-hidden className="hidden h-px w-6 bg-[#EAECEF] md:inline-block" />
            )}
          </React.Fragment>
        );
      })}
    </nav>
  );
};

export default WizardStepper;
